module.exports = __webpack_public_path__ + "static/media/Rectangle 594.094999ca.png";